export function getWeekOldDate(numOfWeeks: number, date: Date = new Date()): Date {
  date.setDate(date.getDate() - numOfWeeks * 7);
  return date;
}

export const isNumber = (value: unknown): string | null => {
  if (value === "" || value == null || (typeof value === "number" && !Number.isNaN(value))) return null;
  if (typeof value === "string") {
    return /^([0-9]+(\.|\,?[0-9]?[0-9]?)?)/.test(value) ? null : "Value should be a number (max 2 decimals)";
  }
  return "Value should be a number (max 2 decimals)";
};

export const DOCUMENT_NUMBER_ERROR_MESSAGE = "Format: L000-000-000";

export function normalizeUppercaseValue(value: string | null | undefined): string {
  return (value || "").toUpperCase();
}

export function toValidDate(value: any): Date | null {
  if (!value) return null;
  if (value instanceof Date && !isNaN(value.getTime())) return value;
  if (typeof value?.toDate === "function") {
    const parsed = value.toDate();
    return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : null;
  }
  if (typeof value?.seconds === "number") {
    const parsed = new Date(value.seconds * 1000);
    return !isNaN(parsed.getTime()) ? parsed : null;
  }
  if (typeof value?._seconds === "number") {
    const parsed = new Date(value._seconds * 1000);
    return !isNaN(parsed.getTime()) ? parsed : null;
  }
  const parsed = new Date(value);
  return !isNaN(parsed.getTime()) ? parsed : null;
}

export function getSingleDayDateRange(value: any): [Date, Date] | null {
  const parsedDate = toValidDate(value);
  if (!parsedDate) return null;

  const startDate = new Date(parsedDate);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(parsedDate);
  endDate.setHours(23, 59, 59, 999);

  return [startDate, endDate];
}

export const getTimezoneAbbreviation = (date: Date): string => {
  const formatter = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' });
  const parts = formatter.formatToParts(date);
  const timezonePart = parts.find(part => part.type === 'timeZoneName');
  return timezonePart ? timezonePart.value : '';
};

export const formatValue = (type: string, value: any): any => {
  const options: Intl.DateTimeFormatOptions = {
    year: "2-digit",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

  switch (type) {
    case "DATE":
      const sec = value?.seconds || value?._seconds;
      if (sec) {
        return new Date(sec * 1000).toLocaleDateString('en-GB', options) || "Unknown";
      } else {
        if (!value) return "";
        const parsed = new Date(value);
        if (isNaN(parsed.getTime())) return "";
        return parsed.toLocaleDateString('en-GB', options) || "Unknown";
      }
    case "COORDINATE":
      return Array.isArray(value) ? value.join(", ") : value;
    case "NUMBER":
      return value != null && value !== "" ? Number(value) : "";
    case "BOOLEAN":
      return value;
    case "STRING_ARRAY":
      return value;
    default:
      return value?.toString() ?? "No value";
  }
};

export function replaceUndefinedWithNull(data: any): any {
  if (data === undefined) return null;
  if (data === null) return null;
  if (Array.isArray(data)) {
    return data.map(item => replaceUndefinedWithNull(item));
  }
  if (typeof data === "object") {
    const proto = Object.getPrototypeOf(data);
    if (proto !== null && proto !== Object.prototype) {
      return data;
    }
    const cleaned: any = {};
    Object.keys(data).forEach(key => {
      cleaned[key] = replaceUndefinedWithNull(data[key]);
    });
    return cleaned;
  }
  return data;
}
